<div class="advanced-search">
  <h1 class="typography--title u-m-b-16">Job Status Summary</h1>
  <div class="advanced-search__form-wrapper">
    <div class="advanced-search__form">
      <form name="schoolSearchForm" aria-label="Search for job status summary" novalidate [formGroup]="form" (ngSubmit)="onSearch()">
        <div class="advanced-search__field">
          <label for="fromDate" class="advanced-search__label">From Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="fromDate" formControlName="fromDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="toDate" class="advanced-search__label">To Date</label>
          <div class="advanced-search__input">
            <input type="datetime-local" id="toDate" formControlName="toDate" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="jobName" class="advanced-search__label">Job Name</label>
          <div class="advanced-search__input">
            <input type="text" id="jobName" formControlName="jobName" />
          </div>
        </div>
        <div class="advanced-search__field">
          <label for="state" class="advanced-search__label">State</label>
          <div class="advanced-search__input">
            <select id="state" formControlName="state">
              <option value="">All</option>
              <option value="0">Pending</option>
              <option value="1">Running</option>
              <option value="2">Completed</option>
              <option value="3">Failed</option>
            </select>
          </div>
        </div>
        <div class="row align-right">
          <div class="advanced-search__submit btn-group">
            <button type="submit" class="btn btn--elevated btn-group__btn">Search</button>
          </div>
        </div>
      </form>
      <div class="full-page-spinner" [class.full-page-spinner--is-active]="(summarySearchState$ | async).loading">
        <div class="full-page-spinner__icon"></div>
      </div>
    </div>
  </div>
</div>
